import { useEffect, useState } from 'react';
import PaginationSection from './pagination/PaginationSection';
import usePaginatedTable from '../hooks/UsePaginatedTable';
import CheckboxSelectAllBulk from './CheckboxSelectAllBulk';

function CardContainer({
  rowsPerPage,
  batchSelectedElements,
  setBatchSelectedElements,
  data,
  setData,
  cards,
  useCheckboox,
  cardDataPropName,
  cardDataKey,
}) {
  const [page, setPage] = useState(1);
  const { slice, range } = usePaginatedTable(cards, page, rowsPerPage);

  return (
    <div className='d-flex flex-column gap-3'>
      {useCheckboox && (
        <CheckboxSelectAllBulk
          batchSelectedElements={batchSelectedElements}
          data={data}
          setBatchSelectedElements={setBatchSelectedElements}
          slice={slice}
          includeText={true}
          id='cb-select-all'
          cardDataPropName={cardDataPropName}
          cardDataKey={cardDataKey}
        />
      )}
      <div className='d-flex flex-column gap-3'>{slice}</div>
      <PaginationSection
        page={page}
        range={range}
        slice={slice}
        setPage={setPage}
      />
    </div>
  );
}

export default CardContainer;
